import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Components
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
} from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import { Typography } from '@mui/material';

//Actions
import {
    deleteClipRequestRequest,
    clearRedux,
} from 'Redux/actions';

const DeleteClipRequest = (props) => {
    const { tableRef } = props;
    const dispatch = useDispatch();

    const { messages } = useIntl();

    const { loading, openModal, clipRequest, result } = useSelector(state => state.deleteClipRequestRedux);

    const closeModal = () => {
        dispatch(clearRedux("DELETE_CLIP_REQUEST"));
    }

    const deleteClip = () => {
        let payload = {
            id: clipRequest?.id
        }
        dispatch(deleteClipRequestRequest(payload))
    }

    useEffect(() => {
        if (result) {
            if(result?.delete){
                NotificationManager.success(
                    messages['delete_clip_request_success_message'],
                    messages['delete_clip_request_title'],
                    3000
                );
                tableRef && tableRef.current?.getData();
                closeModal();
            }else {
                NotificationManager.error(
                    messages['delete_clip_request_error_message'],
                    messages['delete_clip_request_title'],
                    3000
                );
                dispatch(clearRedux("DELETE_CLIP_REQUEST", { result: null }));
            }
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['delete_clip_request_title']}
            size="small"
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <Typography
                        variant="subtitle2"
                        color="textSecondary"
                    >
                        {messages['delete_clip_request_message']}
                    </Typography>
                </div>
            </ModalBody>
            <ModalFooter>
                <div>
                    <Button
                        className="btn btn-cancel"
                        onClick={(e) => closeModal()}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        className="btn-dark-blue"
                        onClick={(e) => deleteClip()}
                    >
                        {messages['delete']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}
export default DeleteClipRequest;